// User Model
import { Model } from '@vuex-orm/core';

export default class Thread extends Model {
    // This is the name used as module name of the Vuex Store.

    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    static fields() {
        return {
            id: this.attr(null),
            unread: this.attr(''),
            picture: this.attr(''),
            no_reply: this.attr(false),
            last_activity: this.attr(null),
            last_activity_readable: this.attr(null),
            messages: this.attr([]),
            partners: this.attr([]),
            presence: this.attr([]),
            sent_message_ids: this.attr([]),
        };
    }

}

Thread.entity = 'threads';
Thread.apiConfig = {
    actions: {
        fetch(pageId = 1) {
            const params = new URLSearchParams();
            params.append('page', pageId);
            return new Promise((resolve) => {
                this.get('/api/v3/inbox', {
                    params,
                    dataTransformer: (response) => response.data.data,
                }).then((response) => {
                    resolve(response);
                });
            });
        },
        fetchById(id) {
            return new Promise((resolve) => {
                this.get(`/api/v3/inbox/${id}`, {
                    dataTransformer: (response) => response.data.data,
                }).then((response) => {
                    resolve(response);
                });
            });
        },
        start(data, recipient_ids) {
            data.recipient_ids = [recipient_ids.id];
            return new Promise((resolve) => {
                this.post('/api/v3/inbox', data, {
                    // we need to save the response to the store to redirect the user to the new active thread
                    dataTransformer: (response) => response.data.data,
                }).then((response) => {
                    resolve(response);
                });
            });
        },
        getThreadByUserId(recipient_ids) {
            const params = new URLSearchParams();
            params.append('user_id', recipient_ids);
            return new Promise((resolve) => {
                this.get('/api/v3/inbox',  {
                    params,
                    dataTransformer: (response) => response.data.data,
                }).then((response) => {
                    resolve(response);
                });
            });
        },
        getThreadByChannelId(channel_id){
            const params = new URLSearchParams();
            params.append('channel_id', channel_id);
            return new Promise((resolve) => {
                this.get(`/api/v3/thread/${channel_id}`,  {
                    params,
                    dataTransformer: (response) => response.data.data,
                }).then((response) => {
                    resolve(response);
                });
            });
        },
        deleteThread(threadId, blockUser = 0) {
            return new Promise((resolve) => {
                const body = { 'block': blockUser};
                this.delete(`/api/v3/inbox/${threadId}`, {data: body})
                    .then((response) => {
                        Thread.delete((item) => item.id == threadId);
                        resolve(response);
                    });
            });
        },
        updateLastActivity(threadId, userId){
            return new Promise((resolve) => {
                this.put(`/api/v3/inbox/${threadId}/activity`, null, {
                    save: false,
                }).then((response) => {
                    const now = new Date();
                    //2021-06-07 10:31:07
                    const last_activity = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()} ${now.toLocaleString('nl-NL').split(' ')[1]}`;

                    const thread = Thread.find(parseInt(threadId));

                    if(thread) {
                        const updatedUserIndex = thread.partners.findIndex((partner) => partner.id === userId);

                        Thread.update({
                            where: threadId,
                            data(thread) {
                                thread.partners[updatedUserIndex].last_read = last_activity;
                            }
                        });
                    }

                    resolve(response);
                });
            });
        }
    },
};

window.Thread = Thread;